<template>
  <div id="orderResultpage">
    <div align="center" style="margin-top: 48px" class="orderDiv">
      <div>
        <img
          src="static/qlbank/img_order_result.png"
          width="96px"
          height="72px"
        />
      </div>
      <div style="margin-top: 8px">
        <label style="font-size: 30px">上传图片正在审核中</label>
      </div>
      <div style="margin-top: 8px">
        <label>我们将在24小时内完成审核</label>
      </div>
      <div style="margin-top: 8px">
        <label>此期间请不要申请新的卡片</label>
      </div>
      <div style="margin-top: 8px">
        <label>否则将有可能导致此次申请开卡失败</label>
      </div>
      <b-row class="rowItem">
        <b-col cols="10" class="mx-auto">
          <b-button block variant="primary" @click="complete()">完成</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script scoped>
export default {
  name: "OrderResult_zy",
  data() {
    return {};
  },
  beforeDestroy() {
    this.clearData();
  },
  methods: {
    clearData() {
      localStorage.removeItem("sqjNo");
      localStorage.removeItem("cardLevel");
      localStorage.removeItem("cardProduct");
      localStorage.removeItem("creditDate");
    },
    complete() {
      // 在当前窗口跳转
      window.location.href =
        "https://rcm.zybank.com.cn/ccc/credit-card-web/#/home";
    },
  },
};
</script>

<style lang="less" scoped>
#orderResultpage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .orderDiv {
    position: relative;
    .issue {
      position: fixed;
      bottom: 20px;
      right: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/zyBank/OrderResult_zy.vue